import { randTexture } from '../textures';
import { randPlanet } from './randPlanet';
import { randShip } from './randShip';
import { rand, repeat, seed } from '../utils';
import { ShipConfig, Stage } from '../types';
import { randStory } from './randStory';

const [shipConfig, tokenId] = window.location.search.slice(1).split('+');

export const TOKEN_ID = tokenId;
export const SHIP_CONFIG: ShipConfig = JSON.parse(atob(shipConfig));

export const getSeed = () =>
  SHIP_CONFIG.layers
    .map(l => parseInt(l) + 1)
    .map(n => (n % 4294967296 === 0 ? 1 : n))
    .reduce((s, n) => {
      const v = (s * n) % 4294967296;
      return v === 0 ? 1 : v;
    }, 1);

seed(getSeed());

export const SHIP = randShip();

export const DEFAULT_MATRIX = [
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 1, 1, 1, 1],
  [0, 1, 1, 1, 1],
  [0, 0, 1, 1, 0],
  [0, 1, 0, 1, 1],
  [0, 1, 1, 0, 0],
  [0, 1, 1, 1, 0],
  [0, 1, 1, 1, 0],
  [0, 0, 0, 0, 0],
];
export const DEFAULT_COLORS = [
  'rgb(141,1,8)',
  'rgb(244,53,124)',
  'rgb(236,231,173)',
];

export const SHIP_SHOWCASE_BACKGROUND_TEXTURE = randTexture();

export const STORY = randStory();

export const NUM_STAGES = 5;
export const NUM_LEVELS_PER_STAGE = 5;
export const NUM_LEVELS_TOTAL = NUM_STAGES * NUM_LEVELS_PER_STAGE;

export const STAGES: Stage[] = repeat(NUM_STAGES + 1, () => ({
  background: randTexture(),
  levels: repeat(NUM_LEVELS_PER_STAGE, () => ({
    planeTexture: randTexture(),
    planet: randPlanet(90, 150),
    starMapX: rand(-1, 1),
  })),
}));
